import { render } from "./Recordings.vue?vue&type=template&id=0049f072&scoped=true"
import script from "./Recordings.vue?vue&type=script&setup=true&lang=js"
export * from "./Recordings.vue?vue&type=script&setup=true&lang=js"

import "./Recordings.vue?vue&type=style&index=0&id=0049f072&scoped=true&lang=css"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0049f072"],['__file',"resources/admin/ui/Pages/Devices/Recordings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0049f072"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0049f072', __exports__)) {
    api.reload('0049f072', __exports__)
  }
  
  module.hot.accept("./Recordings.vue?vue&type=template&id=0049f072&scoped=true", () => {
    api.rerender('0049f072', render)
  })

}


export default __exports__